import {
  Container,
  Grid,
  Box,
  Typography,
  CircularProgress,
  Alert,
  Button,
  Paper,
} from "@mui/material";
import { useGetCampaignsQuery } from "../../Apis/campaignApi";
import { campaignModel } from "../../Interfaces";
import { NavLink } from "react-router-dom";

export default function LandingPage() {
  const { data, isLoading } = useGetCampaignsQuery(null);
const activeCampaigns = data?.result?.filter((c:campaignModel)=> c.isActive);

// Get the last active campaign
const activeCampaign = activeCampaigns?.length > 0 ? activeCampaigns[activeCampaigns.length - 1] : null;

  if (isLoading) {
    return (
      <Container
        maxWidth="md"
        sx={{
          my: 5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "30vh",
        }}
      >
        <CircularProgress color="primary" />
      </Container>
    );
  }

  if (!data?.result || !activeCampaign) {
    return (
      <Container maxWidth="sm" sx={{ my: 5 }}>
        <Alert severity="info" sx={{ textAlign: "center" }}>
          Campaign not found.
        </Alert>
      </Container>
    );
  }

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          backgroundColor: "rgba(81, 35, 132, 1)",
          borderRadius: 3,
          boxShadow:2,          
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          width: "100%",
          p: 2,
          
          textAlign: "center",
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          {activeCampaign.name}
        </Typography>
      </Box>

      {/* Campaign Content */}
      <Container sx={{ py: 2 }}>
        <Grid container spacing={4} alignItems="top">
          {/* HTML Description */}
          {/* Image */}
          {activeCampaign.imageUrl && (
            <Grid size={{xs:12,md:4}} >
              <Box
                component="img"
                src={activeCampaign.imageUrl}
                alt={activeCampaign.name}
                sx={{
                  width: "100%",
                  height: "auto",
                  borderRadius: 2,
                  objectFit: "cover",
                }}
              />
            </Grid>
          )}
          <Grid size={{xs:12,md:8}} >
            <Box
              sx={{ fontSize: "1.1rem", lineHeight: 1.6 }}
              dangerouslySetInnerHTML={{ __html: activeCampaign.description }}
            />
          </Grid>

          
        </Grid>
      </Container>

      {/* Call to Action */}
      <Paper
        elevation={0}
        sx={{
          backgroundColor: "#f8f9fa",
          border: "1px solid #e9ecef",
          textAlign: "center",
          p: 4,
          m: 4,
          borderRadius: 3,
        }}
      >
        <Typography variant="h5" sx={{ mb: 2, color: "rgba(81, 35, 132, 1)" }}>
          Ready to Make an Impact?
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, fontSize: "1.1rem" }}>
          If you're interested in this campaign, join us by registering or log
          in if you already have an account.
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Button
            component={NavLink}
            to="/Register"
            variant="contained"
            sx={{
              backgroundColor: "rgba(81, 35, 132, 1)",
              color: "white",
              px: 4,
              py: 1,
              fontWeight: 600,
              "&:hover": { backgroundColor: "rgba(81, 35, 132, 0.9)" },
            }}
          >
            Register Now
          </Button>

          <Button
            component={NavLink}
            to="/login"
            variant="outlined"
            sx={{
              borderColor: "rgba(81, 35, 132, 1)",
              color: "rgba(81, 35, 132, 1)",
              px: 4,
              py: 1,
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "rgba(81, 35, 132, 0.05)",
                borderColor: "rgba(81, 35, 132, 1)",
              },
            }}
          >
            Login
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
